import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import AttributesHome from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/custom-attributes'),
      meta: {
        featureFlag: FEATURE_FLAGS.CUSTOM_ATTRIBUTES,
        permissions: ['administrator'],
      },
      redirect: to => {
        return { name: 'attributes_list', params: to.params };
      },
    },
    {
      path: frontendURL('accounts/:accountId/settings/custom-attributes/list'),
      name: 'attributes_list',
      component: AttributesHome,
      meta: {
        featureFlag: FEATURE_FLAGS.CUSTOM_ATTRIBUTES,
        permissions: ['administrator'],
      },
    },
  ],
};
